// Define flags
export const DEFAULT_CHANNEL = true;
export const DEFAULT_CHANNEL_VALUE = 1;
export const MULTIPLE_CAT_PER_VIDEO = true;
export const MULTIPLE_CAT_PER_SHOW = true;
export const SHOW_OVERVIEW_DASHBOARD = true;
export const SHOW_ADMIN_USERS = false;
export const SHOW_SUBSCRIBERS = true;
export const SHOW_CONTENT_CATEGORIES = true;
export const SHOW_CONTENT_SHOWS = true;
export const SHOW_CONTENT_VIDEOS = true;
export const SHOW_WEB_CONTENT = false;
export const SHOW_REPORTS_OVERVIEW_VIDEOS = true;
export const SHOW_REPORTS_LIVE_USERS = true;
export const SHOW_REPORTS_WATCH_SESSIONS = true;
export const SHOW_REPORTS_APP_SESSIONS = true;
export const SHOW_REPORTS_VIDEO_WATCH_SESSIONS = true;
export const SHOW_CONTACTS = true;

// Define commonly used constants
export const LS_ADMIN_USER_AUTH_TOKEN = '__tcls_admin_t';
export const LS_ADMIN_USER_NAME = '__tcls_admin_n';
export const LS_ADMIN_USER_EMAIL = '__tcls_admin_e';
export const LS_ADMIN_USER_ROLE = '__tcls_admin_r';
export const LS_ADMIN_USER_ID = '__tcls_admin_id';

export const STATUS_LABELS = {
  0: 'Inactive',
  1: 'Active',
  2: 'Deleted',
  5: 'Requested Delete',
  11: 'Pending Verification',
  12: 'Cancellation Applied',
};

export const STATUS_COLORS = {
  0: 'error',
  1: 'success',
  2: 'error',
  5: 'warning',
  11: 'warning',
  12: 'warning',
};

// Valid admin roles
export const VALID_ADMIN_ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  CONTENT_OWNER: 'CONTENT_OWNER',
};

export const WEB_PAGE_TYPE = {
  ABOUT_US: 'ABOUT_US',
  PRIVACY_POLICY: 'PRIVACY_POLICY',
  TERMS_CONDITIONS: 'TERMS_CONDITIONS',
};

export const POSTER_TYPE = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL',
  BIG_POSTER: 'BIG_POSTER',
};

export const CONTENT_ALIAS = {
  CHANNEL_SINGULAR: 'Channel',
  CHANNEL_PLURAL: 'Channels',
  CATEGORY_SINGULAR: 'Category',
  CATEGORY_PLURAL: 'Categories',
  ASSIGN_CATEGORY: 'Assign Category',
  SHOW_SINGULAR: 'Show',
  SHOW_PLURAL: 'Shows',
  ASSIGN_SHOW: 'Assign Show',
  VIDEO_SINGULAR: 'Episode',
  VIDEO_PLURAL: 'Episodes',
  SUBSCRIBER_SINGULAR: 'Subscriber',
  SUBSCRIBER_PLURAL: 'Subscribers',
  WEB_CONTENT: 'Web Content',
  SETTINGS: 'Settings',
};

export const ACTIONS = {
  CREATE: {
    value: 'create',
    label: 'Create New',
  },
  EDIT: {
    value: 'update',
    label: 'Edit',
  },
  VIEW: {
    value: 'view',
    label: 'View',
  },
  DELETE: {
    value: 'delete',
    label: 'Delete',
  },
  CHANGE_PASSWORD: {
    value: 'change_password',
    label: 'Change Password',
  },
  ASSIGN_CATEGORIES: {
    value: 'assign_categories',
    label: `Assign ${CONTENT_ALIAS.CATEGORY_PLURAL}`,
  },
  UPLOAD_MP4: {
    value: 'upload_mp4',
    label: 'Upload Assets',
  },
  UPLOAD_IMAGE: {
    value: 'upload_image',
    label: 'Upload Image',
  },
  MANAGE_EPISODES: {
    value: 'manage_episodes',
    label: 'Manage Episodes',
  },
};

export const SESSION_TYPE = {
  video: 'Video',
  audio: 'Audio',
};

// Place it in CSS file
export const FOCUS_PALETTE_BGCOLOR = 'rgba(255, 255, 255, 0.25)';
